// Base
import { BaseApi } from '../base.api'

// Interface
import {
  IContactUsWebpageApi,
  IContactUsWebpageApiRequest,
  IContactUsWebpageApiResponse,
  IContactUsWebpageGetAttrs,
  ISubmitContactUsAttrs,
} from 'interfaces/webpage/contact-us'

// Constant
import { ApiConstant } from 'constant'
import { axios_renderUrl } from 'utils'
import { IBaseApiRequestPayload } from 'interfaces/api'

export class ContactUsWebpageApi extends BaseApi<IContactUsWebpageApi> implements IContactUsWebpageApiRequest {
  readonly url = ApiConstant.CONTACT_US_URL
  readonly submitUrl = ApiConstant.SUBMIT_CONTACT_US_URL

  private contactUsUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)
  private submitContactUsUrl = axios_renderUrl(ApiConstant.SUBMIT_CONTACT_US_URL, ApiConstant.WEBPAGE)

  /**
   * @description Get contact us webpage
   *
   * @method POST
   * @url /api/kontakkami
   * @access public
   *
   * @param {IContactUsWebpageGetAttrs} payload
   *
   * @return {Promise<IContactUsWebpageApiResponse>} Promise<IContactUsWebpageApiResponse>
   */
  async contactUsWebpage_getContactUs(payload: IContactUsWebpageGetAttrs): Promise<IContactUsWebpageApiResponse> {
    try {
      const response: IContactUsWebpageApiResponse = await this.POST(this.contactUsUrl, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Post contact us form webpage
   *
   * @method POST
   * @access public
   *
   * @return {Promise<IContactUsWebpageApiResponse>} Promise<IContactUsWebpageApiResponse>
   */
  async contactUsWebpage_postContactUsForm(payload: ISubmitContactUsAttrs): Promise<IContactUsWebpageApiResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: this.submitContactUsUrl,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
